<template>
	<div>
		<!-- 上面 -->
		<el-row :gutter="10">
			<div class="footerUp">
				<!-- 左边 -->
				<el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6" :offset="2">
					<div class="grid-content">
						<div class="footerUp-head">客户服务</div>
						<div class="footer-service">
							<div class="service">
								<el-tooltip placement="bottom" effect="light">
									<div slot="content" style="font-size: 18px;">
										<i class="el-icon-phone-outline"></i>
										客服热线：{{mobile}}
									</div>
									<div class="service-item">
										<i class="el-icon-service"></i>
									</div>
								</el-tooltip>
								<div class="service-text">
									<el-button>客服热线</el-button>
								</div>
							</div>

							<div class="service">
								<el-tooltip placement="bottom" effect="light">
									<div slot="content">
										<img :src="domain + ewm" alt="" style="width: 100px;">
									</div>
									<div class="service-item">
										<i class="el-icon-user"></i>
									</div>
								</el-tooltip>
								<div class="service-text">
									在线客服
								</div>
							</div>	
						</div>
					</div>
				</el-col>
				<!-- 中间 -->
				<el-col :xs="0" :sm="7" :md="7" :lg="7" :xl="7">
					<div class="grid-content middle">
						<!-- <div class="footerUp-head">{{title}}</div> -->
						<div class="content">{{description}}</div>
					</div>
				</el-col>
				<!-- 右边 -->
				<el-col :xs="0" :sm="7" :md="7" :lg="7" :xl="7">
					<div class="grid-content">
						<div class="footerUp-head">关注我们</div>
						<div class="footer-service">
							<div class="service">
								<div class="service-item" style="border:none">
									<img
									  style="width: 100px; height: 100px"
									  :src="domain + gzh"
									  >
								</div>
								<div class="service-text">
									公众号
								</div>
							</div>
							<div class="service">
								<div class="service-item" style="border:none">
									<img
									  style="width: 100px; height: 100px"
									  :src="domain + ewm"
									  >
									
								</div>
								<div class="service-text">
									添加好友
								</div>
							</div>	
						</div>
					</div>
				</el-col>	
			</div>
		</el-row>
		
		
		<!-- 下面 -->
		<el-row>
			<el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :push="2">
				<div class="grid-content footerDown">
					<div class="link">友情链接：
					<a :href="item.url" v-for="(item,index) in links" :key="item.Id">{{item.title}} &nbsp;&nbsp;&nbsp;&nbsp;</a>
					</div>
					<div class="copyright"><a href="http://beian.miit.gov.cn" target="_blank">{{beian}}</a></div>
					<div class="copyright">{{copyright}}</div>
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" >
				<div class="bottom">
					<div class="bottom-item" @click="handle('/')">
						<i class="el-icon-s-home"></i>
						<div class="bottom-text">首页</div>
					</div>
					<div class="bottom-item" @click="handle('/list')">
						<i class="el-icon-s-operation"></i>
						<div class="bottom-text">招标公告</div>
					</div>
					<div class="bottom-item" @click="handle('/userCenter')">
						<i class="el-icon-s-custom"></i>
						<div class="bottom-text">会员中心</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
  export default {
	// name:'footer',
    data() {
      return {
		domain:this.$utils.httpUrl,
		copyright:'',
		title:'',
		description:'',
		beian:'',
		links:[],
		gzh:'',
		ewm:'',
		mobile:''
      }
    },
	created(){
		this.getWebConfig()
		this.getLinks()
	},
    methods: {
		getWebConfig(){
			this.$axios({
				url:this.$utils.httpApi + 'index/webConfig'
			}).then(res=>{
				this.copyright = res.data.data.copyright
				this.title = res.data.data.webtitle
				this.description = res.data.data.webdescription
				this.gzh = res.data.data.gzh
				this.ewm = res.data.data.wxewm
				this.beian = res.data.data.beian
				this.mobile = res.data.data.mobile
			})
		},
		getLinks(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getLinks'
			}).then(res=>{
				this.links = res.data.data
			})
		},
		handle(url){
		  this.$router.push(url)
		},
		onSubmit() {
        
		}
    }
  }
  </script>

<style scoped>
	.bottom{
		display: flex;
		justify-content: space-around;
		position:fixed;
		bottom:0;
		width:100%;
		height:50px;
		box-shadow: 12px 0 0 0 rgba(0, 0, 0, 0.1);
		background-color: #DCDFE6;
		margin:0 -28px;
	}
	.bottom-item{
		display: flex;
		flex-direction: column;
		text-align: center;
		align-items: center;
		font-size: 1rem;
	}
	.bottom-text{
		color:#909399;
		font-size: 0.8rem;
	}
	.bottom-item i{
		color:#909399;
		font-size: 1.5rem;
		padding:5px;
	}
	.el-col {
	border-radius: 4px;
	}
	.bg-purple-dark {
	background: #99a9bf;
	}
	.bg-purple {
	background: #d3dce6;
	}
	.bg-purple-light {
	background: #e5e9f2;
	}
	.grid-content {
	border-radius: 4px;
	min-height: 36px;
	}
	.footerDown{
		margin-top: 10px;
	}
	.middle{
		border-left: #DCDFE6 solid 1px;
		border-right: #DCDFE6 solid 1px;
	}
	.time {
	font-size: 13px;
	color: #999;
	}

	.bottom {
	margin-top: 13px;
	line-height: 12px;
	}

	.button {
	padding: 0;
	float: right;
	}

	.image {
	width: 100%;
	display: block;
	}

	.clearfix:before,
	.clearfix:after {
	  display: table;
	  content: "";
	}

	.clearfix:after {
	  clear: both
	}
	.footerUp-head{
		text-align: center;
		font-size: 1.2rem;
		color:#606266;
	}
	.footer-service{
		margin-top: 15px;
		display: flex;
		justify-content: space-around;
	}
	.service:hover{
		cursor: pointer;
	}
	.service-item{
		border: #606266 solid 1px;
		width:100px;
		height:100px;
		font-size: 5rem;
		text-align: center;
		color:#606266;
	}
	.service-text{
		color:#606266;
		font-size: 1rem;
		text-align: center;
		margin-top: 10px;
	}
	.content{
		color:#606266;
		padding: 20px;
	}
	.footerDown{
		width:100%;
		height:90px;
		background-color: #409EFF;
		color:#fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.footerDown a{
		text-decoration: none;
		color: #fff;
	}
	.copyright{
		margin-top: 10px;
	}
</style>